// Initial model shapes for Group Intake form

// Initial facility shape
export const initialFacility = {
  name: '',
  location: '',
  contactPerson: { name: '', email: '', phone: '' },
  facilityDetails: { facilityType: '', traumaLevel: '', teamModel: '' },
  clinicalExpectations: { requiredCaseTypes: [], emrSystem: '' },
};

// Initial listing shape
export const createNewListing = () => ({
  // Required fields to match backend schema
  sourceListingId: `temp-${Date.now()}-${Math.floor(Math.random() * 1000)}`, // Generate a unique temp ID
  title: 'New Position',  // Default title (required field)
  reviewStatus: 'pending', // Draft/unpublished by default; set to 'reviewed' when published
  // Reorganized to match backend schema
  compensation: {
    amount: 80,
    period: 'hourly',
    contractType: 'W2',
    includesHousing: false,
    includesTravel: false,
    malpracticeCovered: false,
  },
  // Other fields
  assignment: { 
    types: [],
    startDate: '' 
  },
  schedule: {
    pattern: '',
    estimatedWeeklyHours: 0,
  },
  clinicalExpectations: { requiredCaseTypes: [], emrSystem: '' },
});

// Create a new facility with one empty listing
export const createNewFacility = () => ({
  ...JSON.parse(JSON.stringify(initialFacility)),
  listings: [createNewListing()],
});

// Initial group shape
export const initialGroup = {
  name: '', 
  description: '', 
  logoUrl: '', 
  website: '',
  contact: { name: '', email: '', phone: '' }
};

// Define steps for the intake form
export const intakeSteps = [
  { 
    id: 'group', 
    name: 'Group Details', 
    icon: 'Building2',
  },
  { 
    id: 'facilities', 
    name: 'Facilities', 
    icon: 'Hospital',
  },
  { 
    id: 'listings', 
    name: 'Listings', 
    icon: 'ListFilter',
  },
  { 
    id: 'review', 
    name: 'Review', 
    icon: 'CheckCircle',
  },
];
